/*
 * @Author: jiangxd
 * @Date: 2021-08-04 11:24:02
 * @LastEditTime: 2021-08-04 11:44:35
 * @LastEditors: jiangxd
 * @Description:
 * @FilePath: /rs_ips_maintence/src/views/components/shopDisplaySketchMap/displayEdit/pageVideo.tsx
 */
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import style from "./style.vue";

export const videoImg = "https://ssl-picture.tenyun.runsasoft.com/shipinbofang.png";
export const tencentVideo = "https://v.qq.com/open/home.html";
export const normalVideo = "https://developers.weixin.qq.com/miniprogram/product/material";

@Component({
	components: {},
	mixins: [style],
})
export default class PageVideo extends Vue {
	@Prop({ default: () => {} })
	value: MiniPageVideo;

	@Prop({ default: false })
	disabled: boolean;

	data: MiniPageVideo = {};

	@Watch("value", { deep: true, immediate: true })
	watchValue(n, o) {
		if (JSON.stringify(n) !== JSON.stringify(o)) {
			this.data = n;
		}
	}

	@Watch("data", { deep: true })
	watchData() {
		this.$emit("input", this.data);
	}

	// 点此了解详情
	openNewWindow(type) {
		window.open(type == 1 ? tencentVideo : normalVideo);
	}

	render(h) {
		return (
			<div class="container margin-top-none r-ma-20" key={this.data.sort}>
				<el-form props={{ model: this.data }} label-width="0" ref="form" disabled={this.disabled}>
					<el-radio-group v-model={this.data.desc.videoSource} class="r-px-0 r-py-12" disabled={this.disabled}>
						<el-radio label={1}>腾讯视频(推荐)</el-radio>
						<el-radio label={2}>普通视频</el-radio>
					</el-radio-group>
					{this.data.desc.videoSource === 1 && (
						<p class="tip">
							注：使用腾讯视频无需申请相关视频资质，如需去除广告/水印，需购买相关服务。
							<span class="scopeSpan" onClick={() => this.openNewWindow(this.data.desc.videoSource)}>
								点此了解详情
							</span>
						</p>
					)}
					{this.data.desc.videoSource === 2 && (
						<p class="tip line-height-18">
							注: 建议使用腾讯云视频点播服务，需取得相关视频播放资质。
							<span class="scopeSpan" onClick={() => this.openNewWindow(this.data.desc.videoSource)}>
								点此了解详情
							</span>
						</p>
					)}
					<div>&nbsp;</div>
					<p class="blockTitle center-text-title">
						视频地址 <span class="redText">*&nbsp;</span>
					</p>
					<el-form-item prop={"desc.videoUrl"} rules={{ required: true, message: "请输入地址", trigger: "blur" }}>
						<el-input v-model={this.data.desc.videoUrl}></el-input>
					</el-form-item>
					<p class="blockTitle center-text-title r-pb-12">是否自动播放</p>
					<el-radio-group v-model={this.data.desc.isAutoPlay}>
						<el-radio label={0}>不自动播放</el-radio>
						<br />
						<el-radio label={1} class="r-px-0 r-py-12">
							仅在wi-fi环境下自动播放
						</el-radio>
						<br />
						<el-radio label={2}>始终自动播放</el-radio>
					</el-radio-group>
				</el-form>
			</div>
		);
	}
}
